import { useTranslation } from 'react-i18next';

import { Box, MenuList, Typography } from '@mui/material';

import { ArrowLeft } from '@/components/icons/ArrowLeft';
import { IconTooltipButton } from '@/components/iconTooltipButton/IconTooltipButton';

import { MultiSelectItem } from './MultiSelectItem';
import { styles } from './MutliSelect.styles';
import type { TMultiSelectSelectedProps } from './types';

export const MultiSelectSelected = ({
  value,
  toggle,
  selectedTitle,
  backToSearch,
}: TMultiSelectSelectedProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Box sx={styles.selectedHeader}>
        <IconTooltipButton label={t('common.back')} onClick={backToSearch}>
          <ArrowLeft />
        </IconTooltipButton>

        <Typography variant="h6">{selectedTitle}</Typography>
      </Box>

      <MenuList sx={styles.options}>
        {value.map((item) => (
          <MultiSelectItem key={item.id} item={item} toggle={() => toggle([item])} selected />
        ))}
      </MenuList>
    </>
  );
};
